"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@mui/material/styles");

var _Collapse = _interopRequireDefault(require("@mui/material/Collapse"));

var _List = _interopRequireDefault(require("@mui/material/List"));

var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));

var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));

var _ListSubheader = _interopRequireDefault(require("@mui/material/ListSubheader"));

var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));

var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton"));

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var _TrendingFlat = _interopRequireDefault(require("@mui/icons-material/TrendingFlat"));

var _ArrowUpward = _interopRequireDefault(require("@mui/icons-material/ArrowUpward"));

var _ArrowDownward = _interopRequireDefault(require("@mui/icons-material/ArrowDownward"));

var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));

var _Remove = _interopRequireDefault(require("@mui/icons-material/Remove"));

var _Table = _interopRequireDefault(require("@mui/material/Table"));

var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));

var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));

var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));

var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));

var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));

var _Card = _interopRequireDefault(require("@mui/material/Card"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Divider = _interopRequireDefault(require("@mui/material/Divider"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _reactI18next = require("react-i18next");

var List = function List(_ref) {
  var data = _ref.data;

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var theme = (0, _styles.useTheme)();

  var getTrendingColor = function getTrendingColor(state) {
    var sign = Math.sign(state);

    if (sign > 0) {
      return theme.palette.success.main;
    } else if (sign === 0) {
      return theme.palette.info.main;
    } else {
      return theme.palette.warning.main;
    }
  };

  var getTrendingIcon = function getTrendingIcon(state) {
    var sign = Math.sign(state);

    if (sign > 0) {
      return /*#__PURE__*/_react.default.createElement(_ArrowUpward.default, null);
    } else if (sign === 0) {
      return /*#__PURE__*/_react.default.createElement(_TrendingFlat.default, null);
    } else {
      return /*#__PURE__*/_react.default.createElement(_ArrowDownward.default, null);
    }
  };

  var getCollapseIcon = function getCollapseIcon(state) {
    return state ? /*#__PURE__*/_react.default.createElement(_Remove.default, {
      sx: {
        color: theme.palette.text.primary
      }
    }) : /*#__PURE__*/_react.default.createElement(_Add.default, {
      sx: {
        color: theme.palette.text.primary
      }
    });
  };

  var boxStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  };

  var handleClick = function handleClick(item) {
    if (item.date === selected.date) {
      setSelected({});
    } else {
      setSelected(item);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_List.default, null, data.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      key: item.date,
      divider: true,
      sx: {
        display: 'list-item',
        pb: '0 !important',
        pt: '0 !important',
        backgroundColor: theme.palette.background.paper
      }
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
      sx: {
        color: getTrendingColor(item.changeMaximum)
      }
    }, getTrendingIcon(item.changeMaximum)), /*#__PURE__*/_react.default.createElement(_ListItemButton.default, {
      onClick: function onClick() {
        return handleClick(item);
      }
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      flex: "1",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle1",
      sx: {
        color: theme.palette.text.primary
      }
    }, t('intlDateTime', {
      val: new Date(item.date)
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "caption",
      sx: {
        color: theme.palette.text.primary
      }
    }, t('intlCurrencyWithOptions', {
      val: item.maximum
    }))), getCollapseIcon(selected.date == item.date))), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
      in: selected.date === item.date,
      orientation: "vertical",
      timeout: "auto"
    }, /*#__PURE__*/_react.default.createElement(_TableContainer.default, {
      component: _Paper.default,
      sx: {
        mt: '4px',
        mb: '4px'
      }
    }, /*#__PURE__*/_react.default.createElement(_Table.default, {
      size: "small"
    }, /*#__PURE__*/_react.default.createElement(_TableBody.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        fontWeight: 'bold'
      },
      variant: "body1"
    }, " ", t('maximum'), " ")), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, " ", t('intlCurrencyWithOptions', {
      val: item.maximum
    }), " ")), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right",
      sx: {
        color: getTrendingColor(item.changeMaximum)
      }
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: boxStyle
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, t('intlCurrencyWithOptions', {
      val: item.changeMaximum
    }), "  "), getTrendingIcon(item.changeMaximum)))), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold'
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        fontWeight: 'bold'
      },
      variant: "body1"
    }, " ", t('minimum'), " ")), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, " ", t('intlCurrencyWithOptions', {
      val: item.minimum
    }), " ")), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right",
      sx: {
        color: getTrendingColor(item.changeMinimum)
      }
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: boxStyle
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, "  ", t('intlCurrencyWithOptions', {
      val: item.changeMinimum
    }), " "), getTrendingIcon(item.changeMinimum)))), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold'
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        fontWeight: 'bold'
      },
      variant: "body1"
    }, " ", t('modal'), " ")), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, " ", t('intlCurrencyWithOptions', {
      val: item.modal
    }), " ")), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right",
      sx: {
        color: getTrendingColor(item.changeModal)
      }
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: boxStyle
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, " ", t('intlCurrencyWithOptions', {
      val: item.changeModal
    }), " "), getTrendingIcon(item.changeModal)))), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold'
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        fontWeight: 'bold'
      },
      variant: "body1"
    }, " ", t('arrivals'), " ")), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, " ", item.arrivals, " ")), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right",
      sx: {
        color: getTrendingColor(item.changeArrivals)
      }
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: boxStyle
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, " ", item.changeArrivals, " "), getTrendingIcon(item.changeArrivals)))))))));
  }));
};

exports.List = List;